import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import './VehicleDisclaimersContent.scss';

function isDisclaimerValid(disclaimerValue) {
    return disclaimerValue && disclaimerValue.trim();
}

function disclaimerTemplateFromList(disclaimers) {
    return Object.values(disclaimers).map(
        (disclaimer) =>
            isDisclaimerValid(disclaimer) && (
                <span key={disclaimer}>
                    {disclaimer}
                    &nbsp;
                </span>
            )
    );
}

const VehicleDisclaimersContent = ({ disclaimers, disclaimersContentZone, genericDisclaimers }) => {
    return (
        <div className="VehicleDisclaimersContent">
            {disclaimers && <p>{disclaimerTemplateFromList(disclaimers)}</p>}
            {!isEmpty(genericDisclaimers) && <p>{disclaimerTemplateFromList(genericDisclaimers)}</p>}
            {isDisclaimerValid(disclaimersContentZone) && (
                <p>
                    <span>{disclaimersContentZone}</span>
                </p>
            )}
        </div>
    );
};

VehicleDisclaimersContent.defaultProps = {
    disclaimers: null,
    disclaimersContentZone: '',
    genericDisclaimers: [],
};

VehicleDisclaimersContent.propTypes = {
    /** Disclaimers from the Showroom API */
    disclaimers: PropTypes.shape({
        vehicleDescription: PropTypes.string,
        sellingPrice: PropTypes.string,
        priceInclusions: PropTypes.string,
        priceExclusions: PropTypes.string,
        termAndApr: PropTypes.string,
        paymentAndCash: PropTypes.string,
        obligationAndInterest: PropTypes.string,
        creditApproval: PropTypes.string,
    }),
    genericDisclaimers: PropTypes.arrayOf(PropTypes.string),
    disclaimersContentZone: PropTypes.string,
};

export default VehicleDisclaimersContent;



// WEBPACK FOOTER //
// ./src/Vehicle/components/VehicleDisclaimersContent/VehicleDisclaimersContent.jsx